import { Match, Show, Switch } from 'solid-js'

export type CurrentFastProgressVisualizationState =
   | { type: 'hidden' }
   | { type: 'none' }
   | { type: 'message'; message: string }
   | { type: 'icons'; count: number; overflow: number; ariaLabel: string }

/**
 * Renders the milestone/fat-burn visualization (message or icon row) for the current fast.
 *
 * @param props - The visualization state.
 * @returns The visualization element.
 */
const CurrentFastProgressVisualization = (props: {
   state: CurrentFastProgressVisualizationState
}) => (
   <div
      id="current-fast-progress-visualization"
      class="flex min-h-8 items-center justify-center"
      classList={{ hidden: props.state.type === 'hidden' }}
   >
      <Switch>
         <Match when={props.state.type === 'message' && props.state}>
            {state => (
               <div class="flex items-center gap-2 text-sm text-emerald-100/80">
                  <span class="text-2xl">🔥</span>
                  <span>{state().type === 'message' ? state().message : ''}</span>
               </div>
            )}
         </Match>
         <Match when={props.state.type === 'icons' && props.state}>
            {state => (
               <div
                  class="flex max-w-xs flex-wrap items-center justify-center gap-1 text-2xl leading-none"
                  aria-label={state().type === 'icons' ? state().ariaLabel : ''}
               >
                  <span>
                     {state().type === 'icons' ? '🍫'.repeat(state().count) : ''}
                  </span>
                  <Show when={state().type === 'icons' && state().overflow > 0}>
                     <span class="text-sm font-semibold text-emerald-200">
                        +{state().type === 'icons' ? state().overflow : 0}
                     </span>
                  </Show>
                  <span class="text-xl">🔥</span>
               </div>
            )}
         </Match>
      </Switch>
   </div>
)

export default CurrentFastProgressVisualization
